export default __webpack_public_path__ + "gray_matter/impactfigure-9791b7be271a8788a5ea21a90e1b75db.svg";